import { render, staticRenderFns } from "./WidgetChart.vue?vue&type=template&id=d2d5579e&scoped=true"
import script from "./WidgetChart.vue?vue&type=script&lang=js"
export * from "./WidgetChart.vue?vue&type=script&lang=js"
import style0 from "./WidgetChart.vue?vue&type=style&index=0&id=d2d5579e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2d5579e",
  null
  
)

export default component.exports